import { PropsWithChildren } from 'react';

export const Root = ({
  className,
  children,
}: PropsWithChildren<{
  className?: string;
}>) => {
  return <div className={className}>{children}</div>;
};
